import { TypeIcon } from 'core/types';

export const bracketLeft: TypeIcon = {
  viewBox: '0 0 72 148',
  path: '<path d="M69.5 1.50866C49.5 12.9745 33.3 31.5311 20.9 57.1784C11.3 76.9922 6.5 98.0632 6.5 120.391C6.5 129.645 7.4 138.697 9.2 147.547L7.85 148C3.95 128.287 2 113.301 2 103.042C2 90.9725 5.2 76.7407 11.6 60.3466C16 48.9813 23.65 37.5657 34.55 26.0999C45.55 14.5335 57.15 5.83351 69.35 0L69.5 1.50866Z"/>',
};
